<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-6">
        <div class="form-group">
          <label for="attendance-date">التاريخ</label>
          <input
            v-model="selectedDate"
            type="date"
            id="attendance-date"
            class="form-control"
            @change="onDateChange"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
            >
              {{ size }}
            </b-dropdown-item>
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc.sync="false"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
       
          <template #cell(action)="data">
            <b-button variant="success" @click="sendRowAttendance(data.item)">
              تسجيل الحضور <i class="fa fa-check"></i>
            </b-button> 
          </template>
        </b-table>
        <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />

        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import controller from "../../../../Controllers/AttendanceController";
import axios from 'axios'
import swal from 'sweetalert2'
export default {
  name: "AttendanceAdminDataTable",
  props: ["items", "editItem"],
  data() {
    return {
      bootstrapTable: {
        fields: [
          {
            key: "SubjectCode",
            label: "المقرر",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key: "SemesterCode",
            label: "الفصل",
            sortable: true,
            sortDirection: "desc",
          },
          {
            key : "AttendanceDate",
            label: "التاريخ",
            sortable: true,
            sortDirection: "desc",
          },
       
          { key: "action", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: {},
      selectedDate: "", // Empty by default to return all data
      
      currentPage: 1,
      page: 1,
      perPage: 5,
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
    };
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().getAttendanceByDate(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { 
        per_page: this.perPage,
      };
      if (this.selectedDate) {
        apiParams.date = this.selectedDate;
      }
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    onDateChange() {
      // Refresh data when date changes
      this.currentPage = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    // Formats various date strings to DD/MM/YYYY
    formatDateToDMY(dateStr) {
      if (!dateStr) return ''
      if (dateStr.includes('/')) return dateStr
      if (dateStr.includes('-')) {
        const [year, month, day] = dateStr.split('-')
        return `${day}/${month}/${year}`
      }
      const d = new Date(dateStr)
      if (!isNaN(d)) {
        const day = String(d.getDate()).padStart(2, '0')
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const year = d.getFullYear()
        return `${day}/${month}/${year}`
      }
      return dateStr
    },
    async sendRowAttendance(row) {
      const rowDate = row && row.AttendanceDate
      if (!rowDate) {
        console.warn('Row has no AttendanceDate')
        return
      }
      swal.fire({
        title: 'جاري تسجيل الحضور',
        icon: 'info',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      })
      try {
        const formatted = this.formatDateToDMY(rowDate)
        const response = await axios.get('/attendance', { params: { date: formatted, SubjectCode: row.SubjectCode, SemesterCode: row.SemesterCode } })
        swal.fire({
          title: response.data == 'No attendance data available' ? 'لا يوجد بيانات للحضور' : 
          response.data == 'Done' ? 'تم تسجيل الحضور بنجاح' : 'هناك خطأ',
          icon: response.data == 'No attendance data available' ? 'info' : response.data == 'Done' ? 'success' : 'error',
          position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        })
      } catch (error) {
        swal.fire({
          title: 'هناك خطأ  ',
          icon: 'error',
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        })
      }
    },
  },
};
</script>
